// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { getDaysInYear as fn } from "../getDaysInYear.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const getDaysInYear = convertToFP(fn, 1);

// Fallback for modularized imports:
export default getDaysInYear;
